import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { connect } from 'react-redux';

import OwlCarousel from '../../features/owl-carousel';
import ALink from '../../common/ALink';

import { categorySlider } from '../../../utils/data/slider';
import useTranslation from '../../../utils/hooks/useTranslation';

function CategorySection({ categories }) {
    const { t } = useTranslation();

    return (
        <section className="category-section-modern">
            <div className="section-header">
                <span className="section-eyebrow">{t('message.shop_by_category')}</span>
                <h2>{t('message.browse_our_categories')}</h2>
                <p className="section-subtitle">{t('message.discover_categories_subtitle')}</p>
            </div>

            <OwlCarousel adClass="categories-slider-modern modern-slider owl-theme" options={categorySlider}>
                {categories?.map((category) => (
                    <div className="category-card" key={`category-${category.id}`}>
                        <ALink href={`/shop?category=${category.id}`}>
                            <figure>
                                <LazyLoadImage
                                    alt={category.name}
                                    src={process.env.REACT_APP_PUBLIC_ASSET_URI + category.image_url}
                                    width="100%"
                                    height="100%"
                                    threshold={500}
                                    effect="opacity"
                                />
                            </figure>
                            <span className="category-overlay" />
                            <div className="category-card-label">
                                <h3>{category.name}</h3>
                                <span className="category-arrow" aria-hidden="true">
                                    <i className="icon-angle-right" />
                                </span>
                            </div>
                        </ALink>
                    </div>
                ))}
            </OwlCarousel>
        </section>
    );
}

const mapStateToProps = (state) => ({
    categories: state.categories.list
});

export default connect(mapStateToProps, {})(CategorySection);
